// @material-ui/core
import { Grid, Typography } from "@material-ui/core";
import React, { Component } from "react";
import Caba from "../../services/Caba";
import Button from "../button/MainButton";

export function withDelete(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        object: {
          name: ""
        }
      };

      props.toggleLoading(true);
      // make a call
      Caba.get(`/api/v1/${props.slug}/${props.match.params.id}`).then(
        response => {
          this.props.toggleLoading(false);
          this.setState({
            object: response.data
          });
        }
      );
    }

    handleDelete = () => {
      Caba.delete(
        `/api/v1/${this.props.slug}/${this.props.match.params.id}`,
        {}
      ).then(response => {
        this.props.history.push(`/${this.props.slug}`);
        if (response.status === 204) {
          this.props.notify("success", response.status, "Deleted");
        } else {
          this.props.notify("error", 500, response.status);
        }
      });
    };

    handleCancel = () => {
      this.props.history.goBack();
    };

    render() {
      const { object } = this.state;
      return (
        <Grid container>
          <Grid item xs={12}>
            <Typography type="subheading">
              Do you want to delete&nbsp;
              <strong>{object.name ? object.name : object.id}</strong>?
            </Typography>
            <WrappedComponent {...this.props} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Button raised fullWidth onClick={this.handleCancel}>
              Cancel
            </Button>
          </Grid>

          <Grid item xs={12} md={6}>
            <Button raised fullWidth colored="red" onClick={this.handleDelete}>
              Delete
            </Button>
          </Grid>
        </Grid>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/library/pages/withDelete.js